var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.results.rows)?_c('b-tooltip',{attrs:{"label":"Download This Page of Results"}},[(_vm.csvData)?_c('a',{attrs:{"download":"export.csv","href":_vm.csvData}},[_c('b-icon',{attrs:{"pack":"fas","icon":"download"}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }